











































































































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BFormTextarea,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BInputGroupAppend,
  BInputGroup
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Parametre, ParametreCreateModel } from "@/api/models/parametres/parametre";
import { TypesParametreEnum } from "@/api/models/enums/typesParametreEnum";
import { PerimetreEnum } from "@/api/models/enums/perimetresEnum";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormTextarea,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BInputGroupAppend,
    BInputGroup
  },
  name: "create-parametre",
})
export default class CreateParametre extends Vue {
  @Prop({ required: true, type: Boolean }) isCreateParametreSidebarActive!: boolean;

  loading = false;
  required = required;

  optionsType = TypesParametreEnum
  optionsPerimetre = PerimetreEnum

  parametre: ParametreCreateModel = {};
  stringList: string[] = []
  newValeur = ""

  closeSidebar() {
    this.parametre = {}
    this.$emit("update:is-create-parametre-sidebar-active", false);
  }
  
  addValeur() {
    this.stringList.push(this.newValeur)
    this.newValeur = ""
  }

  removeValeur(index: number) {
    this.stringList.splice(index, 1)
  }

  async submit() {
    this.loading = true;
    if (this.parametre.type == 'stringlist')
    {
    this.parametre.valeur = JSON.stringify(this.stringList);
    }
    await this.$http.myressif.parametres
      .post(
        this.parametre
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un paramètre",
            text: "Paramètre créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-parametre");
        this.$emit("update:is-create-parametre-sidebar-active", false);
        this.loading = false;
      });
  }
}
